import * as actionTypes from './actionTypes';
import {getData} from "../../shared/networkUtil";


export const getPortalSettingsRequest = () => ({
    type: actionTypes.GET_PORTAL_SETTINGS_REQUEST
});

export const getPortalSettingsSuccess = portalSettings => ({
    type: actionTypes.GET_PORTAL_SETTINGS_SUCCESS,
    data: portalSettings
});

export const getPortalSettingsError = error => ({
    type: actionTypes.GET_PORTAL_SETTINGS_ERROR,
    error: error
});

export const getPortalSettings = (accountId) => dispatch => {
    dispatch(getPortalSettingsRequest());
    getData(
        "/giftcards/" + accountId + "/portal_settings",
        response => {
            dispatch(getPortalSettingsSuccess(response.data));
        },
        error => {
            console.log(error);
            dispatch(getPortalSettingsError(error));
        }
    );
};
